module.exports = __webpack_public_path__ + "Idea.89a3500c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/Idea.png
// module id = 1512
// module chunks = 0